<template>
  <div class="flex flex-col" @click="$emit('click', $event)">
    <div
      class="h-12 flex items-center relative hover:bg-gray-10"
      :class="[
        paddingInset && 'px-4',
        filled && 'bg-gray-10 border-b border-gray-50'
      ]"
    >
      <div v-if="isFocused" :class="$style.focusState"></div>
      <i class="material-icons px-4 type-scale-4 select-none" v-if="icon">{{
        icon
      }}</i>
      <input
        @focus="onFocus"
        @blur="onBlur"
        @keydown.enter="$emit('enter')"
        v-model="inputValue"
        v-bind="$attrs"
        type="text"
        :readonly="readonly"
        class="h-full w-full focus:outline-none bg-transparent type-scale-n1"
        :class="readonly && 'pointer-events-none'"
      />
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppTextField',

  inheritAttrs: false,

  props: {
    paddingInset: Boolean,
    filled: Boolean,
    icon: String,
    readonly: Boolean,
    value: null
  },

  data() {
    return {
      isFocused: false
    }
  },

  computed: {
    inputValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    onBlur() {
      this.isFocused = false
      this.$emit('blur')
    },

    onFocus() {
      this.isFocused = true
      this.$emit('focus')
    }
  }
}
</script>

<style lang="postcss" module>
.focusState {
  top: 2px;
  left: 2px;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  outline: 2px solid theme('colors.primary.default');
  @apply absolute pointer-events-none;
}
</style>
